import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';

export const BRAND_CONFIG = {
  [SERVICE.MUSINSA]: {
    contactEmail: 'musinsa_curator-g@musinsa.com',
    serviceName: '무신사',
    shopUrlPrefix: 'musinsa.com/curator/s/',
    agreedTerms: ['SERVICE_TERMS_V2', 'SERVICE_POLICY_V1'] as const,
    productImageAspectRatio: '5/6',
  },
  [SERVICE['29CM']]: {
    contactEmail: '29cm_curator-g@musinsa.com',
    serviceName: '29CM',
    shopUrlPrefix: 'curator.29cm.co.kr/shop/',
    agreedTerms: ['SERVICE_TERMS', 'SERVICE_POLICY'] as const,
    productImageAspectRatio: '5/5',
  },
} as const;

export type BrandConfig = (typeof BRAND_CONFIG)[keyof typeof BRAND_CONFIG];

const DEFAULT_BRAND_CONFIG = BRAND_CONFIG[SERVICE['29CM']];

export const getBrandConfig = (service: ServiceType): BrandConfig =>
  BRAND_CONFIG[service as keyof typeof BRAND_CONFIG] ?? DEFAULT_BRAND_CONFIG;

export const getRestrictionMessage = (
  restrictionType: string | null,
  { contactEmail, serviceName }: BrandConfig,
): string => {
  if (!restrictionType) return '';

  // NOTE: SELF_CERT_REQUIRED, MINOR는 무신사만 해당됩니다.
  if (serviceName === '무신사' && restrictionType === 'SELF_CERT_REQUIRED') {
    return `본인 인증이 완료된 ${serviceName} 계정 회원만 큐레이터에 가입할 수 있어요.\n${serviceName} 계정 본인 인증 완료 후 다시 가입 신청해주세요.\n▶ 본인 인증하기: ${serviceName} 마이페이지 > 회원 정보 변경 > 인증하기  \n문의채널 ${contactEmail}`;
  }

  if (serviceName === '무신사' && restrictionType === 'MINOR') {
    return `미성년자인 경우 큐레이터 가입이 제한됩니다.\n문의채널 ${contactEmail}`;
  }

  switch (restrictionType) {
    case 'EMPLOYEE':
      return '임직원은 큐레이터에 가입하실 수 없습니다.';
    case 'DRAFT':
      return `가입 심사를 진행하고 있어요.\n가입 심사는 최대 21일까지 소요됩니다. 가입 관련 문의는 내부 담당자에게 문의해주세요.\n문의채널  ${contactEmail}`;
    case 'DEACTIVATED':
      return `현재 ${serviceName} 큐레이터 활동이 정지 되었습니다. 활동 관련 문의는 내부 담당자에게 문의해주세요.\n문의채널  ${contactEmail}`;
    case 'COMPLETE':
    case 'ALREADY_REGISTERED':
      return '';
    default:
      return `죄송합니다. 이번에는 ${serviceName} 큐레이터 회원으로 함께할 수 있는 기회를 드리지 못했습니다.\n문의채널 ${contactEmail}`;
  }
};
